<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-modal"
      dialog-max-height="40rem"
    >
      <template #header>
        {{ ls({ ja: 'アカウントの切替', en: 'Switch Account' }) }}
      </template>
      <div class="jps-modal-content">
        <table class="jps-table">
          <tbody>
            <tr v-for="af in _affiliations" :key="af.organizationId">
              <td>
                <button
                  class="jps-button"
                  @click="jump(af)"
                  :disabled="userStore.getOrgId === af.organizationId"
                >
                  {{ ls(_organizations[af.organizationId].name) }}
                </button>
              </td>
              <td>{{ led(userRoleDef, af.role) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.close) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls, led, langPath } = useI18n()
const router = useRouter()
const { setLoading } = useLoader()
const userStore = useUserStore()
const { getAccount } = useSession()

interface Props {
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _affiliations: Ref<Affiliation[]> = ref([])
const _organizations: Ref<{ [key: string]: Organization }> = ref({})
const openAwait = async () => {
  let { user, organizations } = await getAccount()
  _organizations.value = organizations;
  _affiliations.value = user.affiliations;
  return await modal.value.openAwait<null>()
}
defineExpose({ openAwait })

const userRoleDef = USER_ROLE_DEF

const jump = async (af: Affiliation) => {
  setLoading(true)
  await userStore.switchAccount(af.organizationId)
  router.push(langPath('/management'))
  modal.value.resolve()
}
</script>

<style lang="scss" scoped>
.jps-modal {
  button {
    width: 100%;
  }
}
</style>
